// Google Analytics TrackingID
function getTrackingId() {
  if (process.env.NODE_ENV === 'production') {
    if (global.window && global.window.location.href.includes('klangio.com')) {
      return 'G-FX73VZZ4CC';
    }
    return 'UA-67983997-14';
  }
  return 'UA-67983997-11';
}

export const GA_TRACKING_ID = getTrackingId();

// Google Adwords TrackingID
export const AW_TRACKING_ID = 'AW-739708467';
// Google Adwords ConversionId
export const AW_CONVERSION_ID = 'AW-739708467/n9glCJ6rldsCELOc3OAC';
// Facebook Pixel TrackingID
export const FB_TRACKING_ID = '268340741849291';

// website base URL
export const BASE_URL = 'https://guitar2tabs.com';
export const COMPANY_URL = 'https://klangio.com';
export const AI2NOTES_URL = 'https://ai2notes.com';

export const S2N_BASE_URL = 'https://sing2notes.com';
export const P2N_BASE_URL = 'https://piano2notes.com';
export const MS_BASE_URL = 'https://melodyscanner.com';

// A/B Testing
const PRODUCT_SINGLE_A = 674726;

if (global.window && !localStorage.getItem('AB')) {
  localStorage.setItem('AB', Math.random() > 0.5 ? 'A' : 'B');
}
export const SINGLE_PRODUCT = PRODUCT_SINGLE_A;

export const PRICING_IDS = {
  small: 674731,
  regular: 674734,
  premium: 674742,
};

export const JOBTYPE = 'guitar2tabs';

export const LANGUAGES = ['en', 'de'];

export const RECAPTCHA_SITEKEY = '6LfsUFgdAAAAAK0o41m-TTNvWJtUadFam2QdgPDt';

export const ECARDS_AMOUNTS: any = [
  {
    amount: 3,
    price: '$4.99',
    color: 'green',
    productId: 745293,
    discount: 0.2,
  },
  {
    amount: 10,
    price: '$9.99',
    color: 'yellow',
    productId: 745327,
    discount: 0.2,
  },
  {
    amount: 50,
    price: '$24.99',
    color: 'blue',
    productId: 745328,
    discount: 0.2,
  },
  {
    amount: 100,
    price: '$49.99',
    color: 'pink',
    productId: 745329,
    discount: 0.2,
  },
];

export const TESTIMONIAL_QUOTES = [
  {
    text: `Great application, very intuitive, easy to use and with an error rate of only 10%. Thanks to the creator, thanks to this app I no longer have to search the internet for sheet music😄😄.`,
    name: 'Rasamoelina M.',
    affiliation: 'Songwriter',
    avatar: '/img/face_female.png',
  },
  {
    text: `A great tool for working and experimenting with notes. I am amazed and very positively surprised. Have wonderful moments with it.`,
    name: 'Luis B.',
    affiliation: 'Musician',
    avatar: '/img/face.png',
  },
  {
    text: `Dear developers, I don't know how to express my feelings to you. As a Music teacher and performer I was looking for such a program like this. And you did it!!! Bravo.`,
    name: 'Rauf K.',
    affiliation: 'Teacher',
    avatar: '/img/face_male.png',
  },
  {
    text: `I absolutely love it. I wanted to turn music into notes, and the app does it well...THANKS`,
    name: 'Timothy P.',
    affiliation: 'Teacher',
    avatar: '/img/face_male.png',
  },
];

export const COMPOSER_BLACKLIST = ['Bodo Wartke'];

export const TWITTER_URL = 'https://twitter.com/Klangio';

export const CompactMusicalKeys = [
  { label: 'C major / A minor', value: 'c' },
  { label: 'Db major / Bb minor', value: 'c#' },
  { label: 'D major / B minor', value: 'd' },
  { label: 'Eb major / C minor', value: 'd#' },
  { label: 'E major / C# minor', value: 'e' },
  { label: 'F major / D minor', value: 'f' },
  { label: 'F# major / D# minor', value: 'f#' },
  { label: 'G major / E minor', value: 'g' },
  { label: 'Ab major / F minor', value: 'g#' },
  { label: 'A major / F# minor', value: 'a' },
  { label: 'Bb major / G minor', value: 'a#' },
  { label: 'B major / G# minor', value: 'b' },
];
